import { useEffect } from "react";
import { RefreshCw } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const TXT = {
  de: ["Kurz nicht erreichbar", "Die Seite konnte gerade nicht geladen werden. Bitte in ein paar Sekunden erneut versuchen.", "Neu laden"],
  en: ["Temporarily unavailable", "This page could not be loaded right now. Please try again in a few seconds.", "Reload"],
  es: ["No disponible por un momento", "La página no se ha podido cargar ahora mismo. Inténtelo de nuevo en unos segundos.", "Recargar"],
  nl: ["Even niet bereikbaar", "De pagina kon zojuist niet worden geladen. Probeer het over een paar seconden opnieuw.", "Opnieuw laden"],
  pl: ["Chwilowo niedostępne", "Nie udało się teraz wczytać strony. Spróbuj ponownie za kilka sekund.", "Odśwież"],
  fr: ["Momentanément indisponible", "La page n'a pas pu être chargée. Veuillez réessayer dans quelques secondes.", "Recharger"],
  it: ["Momentaneamente non disponibile", "La pagina non è stata caricata. Riprova tra qualche secondo.", "Ricarica"],
};

/** Serverfehler/Netzproblem beim Laden – bewusst OHNE noindex/404-Signal, damit ein kurzer Backend-Ausfall (z. B. Deploy) echte Seiten nicht aus Google wirft. Einmaliger Auto-Retry. */
export const LoadError = () => {
  const { lang } = useLang();
  const [title, text, retry] = TXT[lang] || TXT.en;
  useEffect(() => {
    const key = `ph_retry:${window.location.pathname}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    const id = setTimeout(() => window.location.reload(), 3000);
    return () => clearTimeout(id);
  }, []);
  return (
    <section className="max-w-3xl mx-auto px-6 py-32 min-h-[60vh] text-center" data-testid="load-error">
      <h1 className="font-serif text-3xl md:text-4xl text-stone-900">{title}</h1>
      <p className="mt-4 text-stone-600">{text}</p>
      <button type="button" onClick={() => window.location.reload()} className="mt-8 inline-flex items-center gap-2 bg-brand text-white rounded-md px-6 h-11 text-sm font-medium hover:opacity-90" data-testid="load-error-retry">
        <RefreshCw className="w-4 h-4" />{retry}
      </button>
    </section>
  );
};
